export enum errorEnum {
  '3DS' = 'error_3ds',
  NEW_QUOTE = 'error_new_quote',
}
